import type { TFunction } from "i18next";
import type { ThemeName } from "./ThemeProvider";

export const themeLabels = (t: TFunction<"shell">, defaulted: string): Record<ThemeName, string> => ({
  defaulted,
  smoked: t($ => $.smokedTheme),
  spectre: t($ => $.spectreTheme),
  reel: t($ => $.reelTheme),
});
